import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ComponentViewerPage from "./Pages/ComponentViewerPage";
import { HomePage } from "./Pages/HomePage";
import { SerieDetailsPage } from "./Pages/SerieDetailsPage";
import LoginPage from './Pages/LoginPage';
import ForgotPassPage from "./Pages/ForgotPassPage";
import NewPassPage from "./Pages/NewPassPage";
import VideoPlayer from "./Pages/VideoPlayer";
import ManagerDashboard from "./Pages/ManagerDashboard";
import AdminSubscriptions from "./Pages/AdminSubscriptions";
// Super admin (casca + telas). O CMS antigo (/manager) continua vivo em paralelo —
// só sai depois que a equipe confirmar que o painel novo cobre tudo.
import AdminLayout from "./Pages/Admin/AdminLayout";
import AdminOverview from "./Pages/Admin/Overview";
import AdminCatalog from "./Pages/Admin/Catalog";
import AdminContents from "./Pages/Admin/Contents";
import AdminFunnel from "./Pages/Admin/Funnel";
import AdminPerfis from "./Pages/Admin/Perfis";
import AdminPagamentos from "./Pages/Admin/Pagamentos";
import AdminDados from "./Pages/Admin/Dados";
import AdminPlanos from "./Pages/Admin/Planos";
import AdminSeguranca from "./Pages/Admin/Seguranca";
import AdminUsers from "./Pages/Admin/Users";
import AdminWebhooks from "./Pages/Admin/Webhooks";
import AdminHome from "./Pages/Admin/Home";
import AdminSeries from "./Pages/Admin/Series";
import AdminBanners from "./Pages/Admin/Banners";
import AdminTemplates from "./Pages/Admin/Templates";
import SignupPage from "./Pages/SignupPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";
import TvPairing from "./Pages/TvPairing";
import VincularTv from "./Pages/VincularTv";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";
import ChangePasswordPage from "./Pages/ChangePasswordPage/ChangePasswordPage";
import RequireAuth from "./Components/RequireAuth";
import PageTracker from "./lib/PageTracker";
// Modo TV: a raiz ganha `.tv-mode` só quando estamos numa TV. Fora dela, `isTV` é false e
// nada de TV aplica — o app de toque fica idêntico. Ver src/lib/tv.js e src/tv.css.
import { isTV } from "./lib/tv";
import TvSpatialNav from "./lib/TvSpatialNav";
import "./tv.css";

const App = () => {
  return (
    <div className={isTV ? "tv-mode" : undefined} style={{ backgroundColor: '#141414', minHeight: '100vh' }}>
      <Router>
        {/* Manda um pageview LIMPO por rota (nome, nunca a URL crua com id). No-op se o
            PostHog estiver desligado. Ver src/lib/PageTracker.jsx. */}
        <PageTracker />
        {/* Navegação por controle remoto — SÓ na TV. Em telefone/desktop nem monta. */}
        {isTV && <TvSpatialNav />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/components_viewer" element={<ComponentViewerPage />} />
          <Route path="/serie_details/:id" element={<SerieDetailsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/esqueci-senha" element={<ForgotPassPage />} />
          <Route path="/nova-senha" element={<NewPassPage />} />
          <Route path="/senha" element={<NewPassPage />} />
          <Route path="/video/:videoId" element={<VideoPlayer />} />
          <Route path="/manager" element={<RequireAuth adminOnly><ManagerDashboard /></RequireAuth>} />
          {/* Painel de super admin — casca com sidebar + telas aninhadas */}
          <Route path="/admin" element={<RequireAuth adminOnly><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminOverview />} />
            <Route path="catalogo" element={<AdminCatalog />} />
            <Route path="conteudos" element={<AdminContents />} />
            <Route path="funil" element={<AdminFunnel />} />
            <Route path="perfis" element={<AdminPerfis />} />
            <Route path="pagamentos" element={<AdminPagamentos />} />
            <Route path="planos" element={<AdminPlanos />} />
            <Route path="seguranca" element={<AdminSeguranca />} />
            <Route path="dados" element={<AdminDados />} />
            <Route path="usuarios" element={<AdminUsers />} />
            <Route path="webhooks" element={<AdminWebhooks />} />
            <Route path="home" element={<AdminHome />} />
            <Route path="series" element={<AdminSeries />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="templates" element={<AdminTemplates />} />
          </Route>
          {/* Painel de assinaturas antigo — mantido até o novo cobrir tudo */}
          <Route path="/admin/assinaturas" element={<RequireAuth adminOnly><AdminSubscriptions /></RequireAuth>} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
          <Route path="/change-password" element={<RequireAuth><ChangePasswordPage /></RequireAuth>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          {/* Login de TV por pareamento: a TV mostra o código (/tv/entrar), o celular
              digita (/tv). Ver Pages/TvPairing e Pages/VincularTv. */}
          <Route path="/tv/entrar" element={<TvPairing />} />
          <Route path="/tv" element={<VincularTv />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
